import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './Guards/AuthGuard';
import { MaincomponentComponent } from './components/maincomponent/maincomponent.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { LoadConfigurationComponent } from './components/load-configuration/load-configuration.component';
import { ReportsComponent } from './components/reports/reports.component';
import { OrdersComponent } from './components/orders/orders.component';
import { TicketsComponent } from './components/tickets/tickets.component';

const routes: Routes = [
  { path: 'maincomponent', component: MaincomponentComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: MaincomponentComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent, data: { deactivateSideNav: true }  },
  {
    path: '',
    loadChildren: './components/home/home.module#HomeModule',
  },
  { path: 'import-loads', component: UploadFileComponent, canActivate: [AuthGuard] },
  { path: 'config-loads', component: LoadConfigurationComponent, canActivate: [AuthGuard] },
  { path: 'tickets', component: TicketsComponent, canActivate: [AuthGuard] },
  {
    path: 'customers',
    loadChildren: './components/customers/customers.module#CustomersModule',
  },
  {
    path: 'deliveries',
    loadChildren: './components/logistic/logistic.module#LogisticModule',
  },
  {
    path: 'code-history',
    loadChildren: './components/code-history/code-history.module#CodeHistoryModule',
  },
  {
    path: 'reports',
    component: ReportsComponent, canActivate: [AuthGuard]
  },
  {
    path: 'orders',
    component: OrdersComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
